export default __webpack_public_path__ + "static/media/sathish_sr.9dac4574.jpeg";